import './CityGuideImagesSection.scss';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { sanityDataset, sanityImagesBaseUrl, sanityProjectId } from '../../../../sanity.io/config';
import { CityGuideImagesSectionProps } from './CityGuideImagesSection.types';

function CityGuideImagesSection({ carouselImages }: CityGuideImagesSectionProps) {
  return (
    <section>
      <div className="city-guide-images-section">
        {carouselImages &&
          carouselImages.length &&
          carouselImages.map(image => {
            const img = image.asset._ref.split('image-')[1].replace('-jpg', '.jpg');
            return (
              <LazyLoadImage
                className="city-guide-images-section-carousel-image"
                src={`${sanityImagesBaseUrl}/${sanityProjectId}/${sanityDataset}/${img}?w=1000&h=1000&fit=max`}
                alt={image.caption}
              />
            );
          })}
      </div>
    </section>
  );
}
export default CityGuideImagesSection;
